import { render, staticRenderFns } from "./HorariosSlider.vue?vue&type=template&id=787e1693&scoped=true&"
import script from "./HorariosSlider.vue?vue&type=script&lang=js&"
export * from "./HorariosSlider.vue?vue&type=script&lang=js&"
import style0 from "./HorariosSlider.vue?vue&type=style&index=0&id=787e1693&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787e1693",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs,VTabsSlider})
